import React from 'react';

/**
 * @props -
 *  @property {object} plan - ruby object plan.rb
 *  @property {object} currentSubscription - subscription.rb, or null
 */

export default class PricingOptionComponent extends React.Component{
  render() {
    const plan = this.props.plan;
    const currentPlanClass = false; // (this.props.isCurrentPlan ? 'active-plan' : '');
    let monthlyPlanActive = false,
    yearlyPlanActive = false;
    if (this.props.currentSubscription && this.props.currentSubscription.stripe_plan_id) {
      if (plan.stripe_monthly_pricing_id === this.props.currentSubscription.stripe_plan_id) {
        monthlyPlanActive = true;
      } else if (plan.stripe_yearly_pricing_id === this.props.currentSubscription.stripe_plan_id) {
        yearlyPlanActive = true;
      }
    }
    return (
      <div className="col-lg-6 col-sm-12">
        <div className={`card pricing-plan-card mb-4 shadow-sm ${currentPlanClass}`}>
          <div className={`card-header header-${this.props.colorClass}`}>
            <h4 className="font-weight-bold">{plan.name}</h4>
          </div>
        <div className="card-body">
          <ul className="list-unstyled">
            <li className="">
              <strong>{plan.keenform_limit}</strong> Keenforms with up to
            </li>
            <li>
              <strong>{plan.form_attribute_limit}</strong> attributes and <strong>{plan.form_rule_limit}</strong> rules
            </li>
            <li><strong>{plan.submissions_limit.toLocaleString()}</strong> Submissions per month</li>
          </ul>
          <button
            type="button"
            disabled={monthlyPlanActive}
            onClick={() => this.props.onButtonClickEvent(plan.stripe_monthly_pricing_id)}
            className="btn btn-xl btn-block btn-outline-info">${plan.price_monthly} <small className="text-muted">Monthly</small>
            {monthlyPlanActive ? <small className="text-muted"> (current plan)</small> : undefined }
          </button>
          <button
            type="button"
            disabled={yearlyPlanActive}
            onClick={() => this.props.onButtonClickEvent(plan.stripe_yearly_pricing_id)}
            className="btn btn-xl btn-block btn-outline-info">${plan.price_yearly} <small className="text-muted">Yearly</small>
            {yearlyPlanActive ? <small className="text-muted"> (current plan)</small> : undefined }
          </button>
        </div>
      </div>
    </div>);
  }
}